module.exports = __webpack_public_path__ + "static/media/kids2.46c28cb0.jpg";